import axios from "axios";
import Swal from "sweetalert2";

const getToken = () => {
    const token = localStorage.getItem('authorization');
    return token;
};

const delToken = () => {
    localStorage.removeItem('authorization');
};

export default async function ValidToken() {
    const token = getToken();

    return await axios
        .post(global.config.backend + "/api/authorization", {
            "authorization": token
        })
        .then((res) => {
            if (res.data.status) {
                return {
                    status: true,
                    data: res.data.data 
                }
            } else {
                delToken();

                return {
                    status: false,
                    data: null
                }
            }
        })
        .catch((error) => {
            Swal.fire({
                title: "Error Connect",
                text: "Error connect to services",
                icon: "warning",
            });

            return {
                status: false,
                data: null
            };
        });
};